import React from 'react';
import * as Scroll from 'react-scroll';
import Presenter from '../../../presenter.js';
import RequestProperties from '../../request.props.js';
import FilterComponent from '../../../../asset/simple_asset/helper/component/FilterComponent.js';

// Component
import RequestReportRow from './RequestReportRow.js';

//Icon
import iconMaping from '../../../../utils/IconMaping.js';

//Utils
import {HandlingSometingWentWrong} from '../../../../utils/HandlingMessage.js'
import TimerConfig from '../../../../utils/TimerConfig.js';
import { toast } from 'react-toastify';
import Pagination from '../../../../component/Pagination.js'
import classnames from 'classnames'
import windowStop from '../../../../utils/windowStop.js';
// // let scroll     = Scroll.animateScroll;
var Events     = Scroll.Events;
var scroll     = Scroll.animateScroll;
var scrollSpy  = Scroll.scrollSpy;

/*const iconCollections = {
  'iconAsc':'icon-sort fa fa-sort-asc',
  'iconDesc':'icon-sort fa fa-sort-desc',
}*/


export default class RequestReportList extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      isLoadingLoadmore: true,
      total: 0,
      rowElement: '',
      activeToggle: {
        activeIcon: null,
        activeField: 'Name',
      },
      // ***Pagination
      table_loading : false,
      current       : 0,
      limit         : 0,
    }
    // Component Filter
    this.tab1 = ['asset', 'type', 'description']

    //* Default Param Filter & Order */
    this.ParamsFilter = 'field=&search=';
    this.ParamsOrder = 'ordering=-SortDate,-CreatedTime';
    this.ParamsPage = 1;

    // Read
    this.onRead        = this.onRead.bind(this)
    this.onReadSuccess = this.onReadSuccess.bind(this)
    this.onReadFailed  = this.onReadFailed.bind(this)
    
    this.onReport        = this.onReport.bind(this)
    this.onReject        = this.onReject.bind(this)
    this.onReportSuccess = this.onReportSuccess.bind(this)
    this.onReportFailed  = this.onReportFailed.bind(this)
  }

  onReport(alias) {
    Presenter.Report(
      RequestProperties.Report(alias, this, this.onReportSuccess, this.onReportFailed)
    )
  }

  onReject(alias) {
    Presenter.RejectReport(
      RequestProperties.RejectReport(this, this.onReportSuccess, this.onReportFailed, alias)
    )
  }

  onRejectReportSuccess(params, response){
    toast.success("Reject Report Success")
    this.onRead();
  }

  onReportSuccess(params, response) {
    toast.success("Execute Success")
    this.onRead();
    // console.log(response);
  }

  onReportFailed(response) {
    console.log('Failed');
  }

  generateRow(row) {
    var element = row.map((val, index) => {
      return (
        <RequestReportRow 
          self={this} 
          RowData={val} 
          key={index} 
          onReport={this.onReport}
          onReject={this.onReject}
        />
      )
    })
    return element;
  }

  /* On Filter */
  dataWillFilter(filter){
    this.ParamsFilter = filter;
    this.ParamsPage   = 1;
    Presenter.ReadReport(RequestProperties.ReadReport("Read", this, this.onReadSuccess, this.onReadFailed, this.ParamsFilter, this.ParamsOrder, this.ParamsPage) )
  }

  /* On Order */
  dataWillOrder(order){
      let parameterOder = 'ordering=' + order;
      this.setState({activeToggle: {
          activeField : order,
          activeIcon  : iconMaping.AVICON_ASC 
      } })

      if(this.ParamsOrder === parameterOder){ // before ==
          this.ParamsOrder = 'ordering=-' + order;
          this.setState({activeToggle: {
              activeField : order,
              activeIcon  : iconMaping.AVICON_DESC  
          } })
      } else {
          this.ParamsOrder = parameterOder;
          this.setState({activeToggle: {
              activeField : order,
              activeIcon  : iconMaping.AVICON_ASC   
          } })
      }

      Presenter.ReadReport( 
        RequestProperties.ReadReport(
          "Read", this, 
          this.onReadSuccess, 
          this.onReadFailed, 
          this.ParamsFilter,  
          this.ParamsOrder,
          this.ParamsPage
        ) 
      )
  }

  /* On Read All Data */
  onRead() {
    Presenter.ReadReport(
      RequestProperties.ReadReport(
        'Read', this, 
        this.onReadSuccess, 
        this.onReadFailed, 
        this.ParamsFilter, 
        this.ParamsOrder,
        this.ParamsPage,
      )
    )
  }

  onReadSuccess(params, response) {
    if(params.action === 'Read') {
      // Read
      
      let tmpData = {};
      tmpData.count    = response.data.count;
      tmpData.results  = response.data.results;
      
      this.setState({
        isLoading         : false,
        isLoadingLoadmore : false,
        isSometingWrong   : false,
        table_loading : false,

        total             : response.data.count,
        data              : tmpData,
        nextPage          : response.data.next,
        limit             : response.data.limit,
        current           : response.data.current,
        rowElement        : this.generateRow(response.data.results)
      })

    }
  }

  onReadFailed(response) {
    console.log(response);
    console.log("Read Failed");
    this.setState({
      table_loading: false
    })
  }

  handlePageClick = (data) => {
    windowStop()
    let selected = data.selected + 1;
    this.ParamsPage = selected
    
    this.setState({ table_loading: true})

    this.onRead();
  };

  /* Readmore */
  LoadMore() {        
    this.setState({isLoadingLoadmore: true})
    Presenter.ReadReport( 
      RequestProperties.ReadReport("Next", this, this.onReadSuccess, this.onReadFailed) 
    )
  }

  renderLoadMoreButton() {
    if(this.state.isLoadingLoadmore) {
      return(<div><button className="btn btn-default" disabled><i className="fa fa-spinner fa-pulse fa-fw"></i>&nbsp;Loading</button></div>)
    } else {
      if(this.state.nextPage != null) {
        return (<div><button className="btn btn-primary" onClick={()=> {this.LoadMore()}}>Load More</button></div>)
      }
    }
  }

  scrollToTop() {
    scroll.scrollToTop();
  }

  componentDidMount() {
    this.onRead();

    this.timeroutWindow = window.setTimeout(function() {         
      if(this.state.isLoading){
        this.setState({
          isLoading       : false,
          loadingLoadMore : false, 
          isSometingWrong : true,
        })
      }
    }.bind(this), TimerConfig.SOMETHING_WRONG_TIME);

    Events.scrollEvent.register('begin', function(to, element) {});
    Events.scrollEvent.register('end', function(to, element) {})
    scrollSpy.update();
  }

  componentWillUnmount() {
    windowStop()
    window.clearTimeout(this.timeroutWindow);
    Events.scrollEvent.remove('begin');
    Events.scrollEvent.remove('end');
  }

  renderTitle(cluster) {
    if(cluster === 'lost') {
      return (
        <div className="row">
          <div className="col-sm-5 book-a-tool-title">
            <h4 className="card-title mb-0">
              <span><span className={iconMaping.AVICON_HOURGLASS}></span>&nbsp;Report Lost</span>
            </h4>
            <div className="text-muted m-top-8">
              <div className="pull-left spaceRRR cursor-default">
                <span>Total:&nbsp;{this.state.total}</span>&nbsp;Asset
              </div>
            </div>
          </div>
          <div className="col-sm-7">
            <FilterComponent onSearch={(e) => {this.dataWillFilter(e)}} self={this} target={'lost'} FBColumn={this.tab1} />
          </div>
        </div>
      )
    } else {
      return(
        <div className="row">
          <div className="col-sm-5 book-a-tool-title">
            <h4 className="card-title mb-0">
              <span><span className={iconMaping.AVICON_HOURGLASS}></span>&nbsp;Report Broken</span>
            </h4>
            <div className="text-muted m-top-8">
              <div className="pull-left spaceRRR cursor-default">
                <span>Total:&nbsp;{this.state.total}</span>&nbsp;Asset
              </div>
            </div>
          </div>
          <div className="col-sm-7">
            <FilterComponent onSearch={(e) => {this.dataWillFilter(e)}} self={this} target={'broken'} FBColumn={this.tab1} />
          </div>
        </div>
      )
    }
  }

  renderRowElement() {
    if ( this.state.isLoading ) {
      return (<tr><td className="table-loading-inside" colSpan="100%">Loading data . . .</td></tr>)
    } 
    else if(this.state.isLoading === false && this.state.isSometingWrong === true){
      return(HandlingSometingWentWrong('table'))
    }
    else if (this.state.total === 0) {
      return (<tr><td className="table-not-found" colSpan="100%"><span className="icon-drawer"></span>&nbsp;data empty</td></tr>)
    } 
    else if (this.state.total > 0) {
      return (this.state.rowElement)
    } 
    else {
      return(HandlingSometingWentWrong('table'))
    }
  }

  render() {
    return (
      <div>
        {this.renderTitle(this.props.Cluster)}
        <table className={classnames("table table-responsive table-hover table-outline mb-0 m-top-15 over-x", {"loading" : this.state.table_loading})}>
          <thead className="thead-default">
            <tr>
              <th onClick={()=>this.dataWillOrder('Asset__Name')} className="pointer">
                Asset/Tool{this.state.activeToggle.activeField === 'Asset__Name' ? <i className={this.state.activeToggle.activeIcon}></i> : ''}
              </th>
              <th onClick={()=>this.dataWillOrder('CreatedBy__first_name')} className="pointer">
                Reported By{this.state.activeToggle.activeField === 'CreatedBy__first_name' ? <i className={this.state.activeToggle.activeIcon}></i> : ''}{this.state.activeToggle.activeField === 'Asset__Name' ? <i className={this.state.activeToggle.activeIcon}></i> : ''}
              </th>
              <th onClick={()=>this.dataWillOrder('Description')} className="pointer">
                Description{this.state.activeToggle.activeField === 'Description' ? <i className={this.state.activeToggle.activeIcon}></i> : ''}
              </th>
              <th className="text-center">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowElement()}
          </tbody>
        </table>
        <div className="row m-top-15">
          <div className="col-md-12 text-center">
            <Pagination
              current  = {this.state.current}
              count    = {this.state.total}
              limit    = {this.state.limit}
              handle   = {this.handlePageClick}
              isLoading= {this.state.table_loading}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/request/helper/component/RequestReport/RequestReportList.js